import script from "./FormCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormCard.vue?vue&type=script&setup=true&lang=ts"

import "./FormCard.vue?vue&type=style&index=0&id=068f8d44&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-068f8d44"]])

export default __exports__